var map = {
	"./black/liandong.png": "3UEu",
	"./blue/liandong.png": "cO//",
	"./white/liandong.png": "peA1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "GCBR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/liandong\.png$
// module id = GCBR
// module chunks = 24